export default {
  namespaced: true,

  state: {
    order: null,
  },

  getters: {
    firstProductTitle: state => {
      return state.order ? state.order.lineItems[0].product.title : null;
    },

    firstImageFromFirstLineItem: state => {
      if (!state.order) return null;

      const lineItem = state.order.lineItems[0];
      const imageId = lineItem.variant.image_id;

      if (!imageId) return lineItem.product.image.src || null;

      const image = lineItem.product.images.find(image => image.id === imageId);
      return image ? image.src : null;
    },

    get: state => {
      return state.order;
    },
  },

  mutations: {
    set: (state, payload) => {
      state.order = payload;
    },
  },
};
